var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tc-section mt-0 tc-bg text-on-screen"},[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 pl-0 pr-0"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }